enum ClaimType {
	DELIVERY_TERM = 'delivery_term',
	CARGO_TERM = 'cargo_term',
	BILL_OF_LADING_CERTIFICATION = 'bill_of_lading_certification',
	BILL_OF_LADING_APPLICABILITY = 'bill_of_lading_applicability'
}

export default ClaimType
